export default "__VITE_ASSET__no4GBEcJ__"